export default "__VITE_ASSET__DhMW8R3S__"